import { Injectable } from '@angular/core';
import { RestApiService } from '../services/rest-api.service';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { AppSettings } from '../app.settings';
import { ConfirmationService } from 'primeng/api';
declare const google: any;

@Injectable()
export class UserCommonService {
  notificationText: any = 'Notifications';
  isNotifications: any;
  userMetaData: any;
  updateAvailable = false;

  constructor(private restApiService: RestApiService,
    private confirmationService: ConfirmationService,
    private storageService: StorageService,
  ) { }
  signOut(): Observable<any> {
    return this.restApiService.delete('/secure/signout', 'page-center');
  }

  signIn(data): Observable<any> {
    return this.restApiService.post('/user-signin', data, 'page-center');
    // return this.restApiService.post('/signin', data, 'page-center');
  }

  shibbolethSign(data): Observable<any> {
    return this.restApiService.post('/users/signin', data, 'page-center')
  }

  v1signIn(data): Observable<any> {
    return this.restApiService.v1post('/signin', data, 'page-center');
  }

  passwordChange(data, userId): Observable<any> {
    return this.restApiService.put(`/secure/users/${userId}/profile/password`, data, 'page-center');
  }

  setPassword(data): Observable<any> {
    return this.restApiService.post('/users/set-password', data, 'page-center');
  }

  getUserProfile(userId): Observable<any> {
    return this.restApiService.get(`/secure/users/${userId}/profile`, 'page-center');
  }

  getV1UserProfile(userId): Observable<any> {
    return this.restApiService.v1get(`/secure/users/${userId}/profile`, 'page-center');
  }

  updateUserProfile(data, userId): Observable<any> {
    return this.restApiService.patch(`/secure/users/${userId}/profile`, data, 'page-center');
  }

  forgotPassword(data): Observable<any> {
    return this.restApiService.post('/users/forgot-password', data, 'page-center');
  }

  resendOTP(data): Observable<any> {
    return this.restApiService.post('/users/resend-otp', data, 'page-center');
  }

  validateOtp(data): Observable<any> {
    return this.restApiService.post('/users/verify-otp', data, 'page-center');
  }

  getServiceAreaId(): Observable<any> {
    return this.restApiService.get('/secure/tenants/servicearea', 'page-center');
  }

  resendEmailVerificationLink(id, type): Observable<any> {
    return this.restApiService.post(`/secure/email-phonenum-verification?userId=${id}&verificationType=${type}`, 'page-center');
  }

  getPrivacyPolicy(): Observable<any> {
    return this.restApiService.get('/tenant-privacy-policy', 'page-center');
  }

  getUserDetail(clientSystemId): Observable<any> {
    return this.restApiService.get(`/secure/users/${clientSystemId}/userinfo`, 'page-center');
  }

  getMetadata(): Observable<any> {
    return this.restApiService
      .get(`/admin/metadata`, 'page-center');
  }

  
  getGoogleMapAutoComplete(data): Observable<any> {
    return this.restApiService.post(`/secure/google-map/v2/autocomplete`,data, 'page-center');
  }

  getGoogleMapLatLng(placeId): Observable<any> {
    return this.restApiService.get(`/secure/google-map/geocode?placeId=${placeId}`, 'page-center');
  }

  getGoogleMapPlace(latLng): Observable<any> {
    return this.restApiService.get(`/secure/google-map/reverse-geocode?latLng=${latLng}`);
  }

  getGoogleMapRoute(data): Observable<any> {
    return this.restApiService.post(`/secure/google-map/v2/route`, data, 'page-center');
  }

  decodePolyline(encoded: string) {
    return google.maps.geometry.encoding.decodePath(encoded);
  }

  updateSavedFilter(data): Observable<any> {
    return this.restApiService.post('/secure/save-filter', data);
  }

  updateFilterDataToLocal(filterData: any, key?, val?) {
    let filters: any[] = this.storageService.getItemFromSessionStorage(AppSettings.SAVE_FILTERS);
    filters = filters ? filters : [];
    const objects = filters.filter(ele => {
      return ele.screenCode === filterData.screenCode;
    });

    if (objects.length === 0) {
      filters.push(filterData);
    } else {
      const index = filters.findIndex(ele => ele.screenCode === filterData.screenCode);
      if (index >= 0) {
        if (key && val) {
          filters[index]['filterData'][key] = val;
        } else {
          filters[index] = filterData;
        }
      }
    }
    this.storageService.setSessionStorage(AppSettings.SAVE_FILTERS, filters);
  }

  getSavedFilters(screenCode: String) {
    let filters: any[] = this.storageService.getItemFromSessionStorage(AppSettings.SAVE_FILTERS);
    filters = filters ? filters : [];
    const objects = filters.filter(ele => {
      return ele.screenCode === screenCode;
    });
    if (objects.length > 0) {
      return objects[0];
    } else {
      return null;
    }
  }

  getUserMetaData() {
    const token  = this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY);
    if (token) {
      this.restApiService.get('/secure/user-metadata', 'page-center').subscribe(data => {
        this.userMetaData = data;
        // this.checkForLatestVersion();

      }, (error) => {
        console.log(error);
      });
    }
  }

  //  checkForLatestVersion(){
  //   let currentVersion;
  //   let latestVersion;
  //   const configKey = AppSettings.WEB_VERSION;
  //   const tenantConfig: any = this.storageService.getItem(AppSettings.TENANT_CONFIG);
  //   if (tenantConfig) {
  //     const element = tenantConfig.find(ele => ele.configKey === configKey);
  //     if (element) {
  //       currentVersion = element.configValue.split(" ")[1];
  //     }
  //   }
  //   if(this.userMetaData){
  //     const updatedEle = this.userMetaData.tenantConfigKeys.find(ele => ele.configKey === configKey);
  //     if(updatedEle){
  //       latestVersion = updatedEle.configValue;
  //     }
  //   }
  //   const result = this.compareVersions(latestVersion, currentVersion);
  //   if(result === 1){
  //     this.updateAvailable = true;
  //     setTimeout(() => {
  //       this.confirmationService.confirm({
  //         message: "Updated version is available. Please re-login",
  //         icon: "pi pi-info-circle",
  //         accept: () => {
  //           this.storageService.setItem(AppSettings.TIME_SETTINGS, this.userMetaData.timeSettingsList);
  //           this.storageService.setItem(AppSettings.TENANT_CONFIG, this.userMetaData.tenantConfigKeys);
  //           this.storageService.setItem(AppSettings.TENANT_INFO, this.userMetaData.tenantInfo);
  //           this.updateAvailable = false;
  //           window.location.reload();
  //         },
  //       });
  //     }, 2000);
  //   }
  // }

  // compareVersions(v1, v2) {
  //   const parts1 = v1.split('.').map(Number);
  //   const parts2 = v2.split('.').map(Number);
  //   for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
  //     const num1 = parts1[i] || 0;
  //     const num2 = parts2[i] || 0;
  //     if (num1 > num2) return 1;
  //     if (num1 < num2) return -1;
  //   }
  //   return 0;
  // }
}

